export default __webpack_public_path__ + "static/media/20-100.ee9719b5.jpg";